import { useState } from "react";
import { useTranslations } from "use-intl";
import clsx from "clsx";
import { useKeenSlider } from "keen-slider/react";
import "keen-slider/keen-slider.min.css";

import { Image } from "../Image";
import { useLocaleInfo } from "@/app/lib/hooks/useLocaleInfo";
import { CheckoutDrawer } from "../CheckoutBanner";

export const OffersCarousel = () => {
  const t = useTranslations();
  const { dir } = useLocaleInfo();
  const [drawerOpen, setDrawerOpen] = useState(false);

  const [sliderRef] = useKeenSlider<HTMLDivElement>({
    loop: true,
    slides: {
      perView: "auto",
      spacing: 8,
      origin: "center",
    },
    renderMode: "performance",
    rtl: dir === "rtl",
  });

  const bannerUrls = [
    { url: "/banners/rahal-1.jpg", alt: "Banner 1" },
    { url: "/banners/rahal-2.jpg", alt: "Banner 2" },
    { url: "/banners/rahal-3.jpg", alt: "Banner 3" },
  ];

  return (
    <div className="max-w-full">
      <div className="mt-2 flex w-full flex-col gap-1 px-4">
        <h6 className="text-xl font-bold text-text-title">
          {t("offers.carouselTitle")}
        </h6>
      </div>

      <div
        className={clsx("py-2", {
          "px-4": bannerUrls.length < 2,
        })}
      >
        <div ref={sliderRef} className="keen-slider">
          {bannerUrls.map(({ url, alt }, index) => (
            <div
              key={url}
              className="keen-slider__slide aspect-[330/128] w-8/10 min-w-8/10 rounded-2xl border-4 border-white"
            >
              <Image
                src={url}
                alt={alt}
                className="size-full object-cover"
                fetchPriority={index === 0 ? "high" : "auto"}
                onClick={() => setDrawerOpen(true)}
              />
            </div>
          ))}
        </div>
      </div>

      <CheckoutDrawer open={drawerOpen} onClose={() => setDrawerOpen(false)} />
    </div>
  );
};
